import { render, staticRenderFns } from "./MServRedirectComp.vue?vue&type=template&id=995b015c&"
import script from "./MServRedirectComp.vue?vue&type=script&lang=js&"
export * from "./MServRedirectComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports